import { Icon } from "@iconify/react/dist/iconify.js";
import { Avatar, Flex, Text, UnstyledButton } from "@mantine/core";
import { useFetcher } from "@remix-run/react";
import { useEffect, useRef } from "react";

import { Notification } from "~/graphql/__generated__/types";
import { formatDate } from "~/lib/date";

export enum TransactionTypeEnum {
  REQUEST_LEAVE = "REQUEST_LEAVE",
  APPROVAL_LEAVE = "APPROVAL_LEAVE",
  REQUEST_OVERTIME = "REQUEST_OVERTIME",
  APPROVAL_OVERTIME = "APPROVAL_OVERTIME",
  REQUEST_DISPENSATION = "REQUEST_DISPENSATION",
  APPROVAL_DISPENSATION = "APPROVAL_DISPENSATION",
  REQUEST_OUTSITE = "REQUEST_OUTSITE",
  APPROVAL_OUTSITE = "APPROVAL_OUTSITE",
  SKPD_VERIFY_OUTSITE = "SKPD_VERIFY_OUTSITE",
  PARTICIPANT_OUTSITE = "PARTICIPANT_OUTSITE",
  DELETE_PARTICIPANT_APPROVAL = "DELETE_PARTICIPANT_APPROVAL",
  DELETE_PARTICIPANT_REQUEST = "DELETE_PARTICIPANT_REQUEST",
  DELETE_PARTICIPANT = "DELETE_PARTICIPANT",
}

export type TransactionType = `${TransactionTypeEnum}`;

const modificationRequestMessage = (message: string, name?: string) => {
  const keyword = "mengajukan";
  const index = message.indexOf(keyword);

  if (index == 0) {
    return (
      <Text fw={400} className="text-[14px]">
        {message}
      </Text>
    );
  }

  if (name) {
    const indexName = message.indexOf(name);
    const before = message.slice(0, indexName).trim();
    const after = message.slice(indexName + name.length).trim();

    return (
      <Text fw={400} className="text-[14px]">
        {before} <b>{name}</b> {after}
      </Text>
    );
  }

  return (
    <Text fw={400} className="text-[14px]">
      {message}
    </Text>
  );
};

const modificationApprovalMessage = (message: string, name?: string) => {
  const keyword = "oleh";
  const index = message.indexOf(keyword) + keyword.length;

  if (index == 0 || !message.includes(keyword)) {
    return (
      <Text fw={400} className="text-[14px]">
        {message}
      </Text>
    );
  }

  if (name) {
    const indexName = message.indexOf(name);
    const before = message.slice(0, indexName).trim();
    const after = message.slice(indexName + name.length).trim();

    return (
      <Text fw={400} className="text-[14px]">
        {before} <b>{name}</b> {after}
      </Text>
    );
  }

  return (
    <Text fw={400} className="text-[14px]">
      {message.slice(0, index).trim()} <b>{message.slice(index).trim()}</b>
    </Text>
  );
};

const getBodyMessage = (type: string, message?: string, name?: string) => {
  if (message) {
    if (type === "REQUEST" || type.includes("REQUEST")) {
      return modificationRequestMessage(message, name);
    }
    if (type === "APPROVAL" || type.includes("APPROVAL")) {
      return modificationApprovalMessage(message, name);
    }
  }
  return message ? (
    <Text fw={600} className="text-[14px]">
      {message}
    </Text>
  ) : (
    ""
  );
};

function NotificationTransactionItem({
  content,
  date,
  type,
  senderEmployee,
  id,
  close,
}: Notification & { close: () => void }) {
  const fetcher = useFetcher();
  const previousState = useRef(fetcher.state);
  const onClickNotif = () => {
    fetcher.submit(
      {},
      {
        method: "POST",
        encType: "application/json",
        action: `/dashboard/notification/${id}/redirect`,
      },
    );
  };

  useEffect(() => {
    if (fetcher.state === "idle" && previousState.current === "loading") {
      close();
    }

    // Update previous state after checking
    previousState.current = fetcher.state;
  }, [fetcher.state]);
  return (
    <Flex py={8} my={8}>
      {content?.web_navigate_to ? (
        //<UnstyledButton onClick={onClickNotif}>
        <UnstyledButton>
          <Flex gap={16} justify={"center"} align={"center"}>
            <Avatar
              radius={"xl"}
              src={
                content && content.iconColor
                  ? undefined
                  : senderEmployee?.filePhoto?.pathUrl
              }
              color={
                content && content.iconColor ? content.iconColor : undefined
              }
              alt={`Avatar of ${senderEmployee?.pegawaiNama}`}
            >
              {content && content.iconColor ? (
                <Icon icon={content.icon} className="h-5 w-5" />
              ) : null}
            </Avatar>
            <Flex direction={"column"}>
              {content.type === "DELETE_PARTICIPANT"
                ? getBodyMessage(
                    type,
                    content && content.body ? content.body : content?.title,
                  )
                : getBodyMessage(
                    type,
                    content && content.body ? content.body : content?.title,
                    senderEmployee?.pegawaiNama
                      ? senderEmployee.pegawaiNama
                      : undefined,
                  )}
              <Text fw={400} size="xs" c="gray">
                {formatDate(date, "DD MMMM YYYY | HH:MM")}
              </Text>
            </Flex>
          </Flex>
        </UnstyledButton>
      ) : (
        <Flex gap={16} justify={"center"} align={"center"}>
          <Avatar
            radius={"xl"}
            src={
              content && content.iconColor
                ? undefined
                : senderEmployee?.filePhoto?.pathUrl
            }
            color={content && content.iconColor ? content.iconColor : undefined}
            alt={`Avatar of ${senderEmployee?.pegawaiNama}`}
          >
            {content && content.iconColor ? (
              <Icon icon={content.icon} className="h-5 w-5" />
            ) : null}
          </Avatar>
          <Flex direction={"column"}>
            {content.type === "DELETE_PARTICIPANT"
              ? getBodyMessage(
                  type,
                  content && content.body ? content.body : content?.title,
                )
              : getBodyMessage(
                  type,
                  content && content.body ? content.body : content?.title,
                  senderEmployee?.pegawaiNama
                    ? senderEmployee.pegawaiNama
                    : undefined,
                )}
            <Text fw={400} size="xs" c="gray">
              {formatDate(date, "DD MMMM YYYY | HH:MM")}
            </Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}

export default NotificationTransactionItem;
